import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {UpdateJsonStockTypes} from "./types/UpdateJsonStockTypes";
import withAuth from "../../hoc/withAuth";
import {Button, Modal} from "antd";
import {SaveOutlined} from "@ant-design/icons";
import Spreadsheet from "react-spreadsheet";
import {withRouter} from "../../hoc/withRouter";
import {fulfillmentService} from "../../services/otodisApi/FulfillmentService";

export interface UpdateJsonStockProps {
}

class UpdateJsonStock extends Component<UpdateJsonStockProps & any, UpdateJsonStockTypes> {
    private columnLabels = ["Stock Code", "Variant Code", "Variant Distributor Code", "Vehicle Color Code", "Vehicle Year"];

    constructor(props: any) {
        super(props);
        this.state = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            processing: false,
            dataTable: [],
            dataSheet: [
                [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
            ],
        }
    }

    onSheetChange = (newData: any) => {
        this.setState({dataSheet: newData});
    };

    onSubmit = async () => {
        await this.promisedSetState({
            processing: true
        });

        const dataFinal = [];
        for (const item of this.state.dataSheet) {
            const stockCode = item?.[0]?.value ?? "";
            const vehicleVariantCode = item?.[1]?.value ?? "";
            const vehicleDistributorCode = item?.[2]?.value ?? "";
            const vehicleColorCode = item?.[3]?.value ?? "";
            const vehicleYear = item?.[4]?.value ?? "";

            if (stockCode && (vehicleVariantCode || vehicleDistributorCode) && vehicleColorCode && vehicleYear) {
                dataFinal.push({
                    stock_code: stockCode,
                    vehicle_variant_code: vehicleVariantCode,
                    vehcile_distributor_code: vehicleDistributorCode,
                    vehicle_color_code: vehicleColorCode,
                    vehicle_year: vehicleYear,
                });
            }
        }

        const jsonData = {
            company: "amarta",
            dealer_code: this.state.dealerCode,
            data: dataFinal,
        }

        if (dataFinal.length < 1) {
            Modal.error({
                title: "Uplaod Error",
                content: "lengkapi minimal 1 baris data",
            });
            this.setState({
                processing: false,
            });
            return;
        }

        try {
            await fulfillmentService.updateJsonStockOtodis(jsonData).then(successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'data berhasil di update'
                });

                this.setState({
                    processing: false,
                    dataTable: [],
                    dataSheet: [
                        [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                        [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                        [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                        [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                        [{value: ""}, {value: ""}, {value: ""}, {value: ""}, {value: ""}],
                    ],
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            this.setState({
                processing: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout breadcrumbPath={`Stock`} breadcrumbMenu={`Update Json Stock`} defaultSelectedKeys={['m-update-json-stock']} defaultOpenKeys={['sm-stock', 'sm-sm-stock-json']}>
                    <Button type={'primary'} icon={<SaveOutlined/>} onClick={this.onSubmit} loading={this.state.processing}>Simpan Data</Button><br/><br/>
                    <div className={`p-20`}>
                        <Spreadsheet data={this.state.dataSheet} columnLabels={this.columnLabels} onChange={this.onSheetChange}/>
                    </div>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default withAuth(withRouter(UpdateJsonStock), 57);